
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import StickyHeader from './components/feature/StickyHeader'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <StickyHeader />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
